<template>
    <div>
        <div v-if="itemRent.onlyStock">
            <i class="icon-only-stock fa-solid fa-grid-2-plus"></i>
        </div>
        <div v-if="itemRent.isAccessory">
            <i class="icon-only-stock fas fa-toolbox"></i>
        </div>
    </div>
</template>

<script>

export default {
    name: "IconTypeEquipament",
    props: ["itemRent", "operational"],
}

</script>
<style scoped>
.icon-only-stock {
    color: #8b92a0
}
</style>